import React from 'react';
import { Typography, Link, Alert } from '@one-thd/sui-atomic-components';
import { RETURN_METHOD } from '@src/constants/general';
import ReturnReviewCard from '@src/components/shared/summary-cards/ReturnReviewCard';
import ItemDetails from '@src/components/shared/summary-cards/ItemDetails';
import { SummaryShipment } from '@src/models/returns';
import LORPContactDetails from '../lorp/lorp-contact-details/LORPContactDetails';

interface LORPGroupedSummaryReturnCardProps {
  shipments: SummaryShipment[];
  handleReturnInstructionsClick: () => void;
}

export const LORPGroupedSummaryReturnCard = ({
  shipments,
  handleReturnInstructionsClick,
}: LORPGroupedSummaryReturnCardProps) => {
  const { lorpContactDetails } = shipments[0] || {};

  const lorpLineItems = shipments?.flatMap((shipment) =>
    shipment.itemsToReturn.filter(
      (item) => item.returnMethod === RETURN_METHOD.LORP,
    ),
  );

  return (
    <ReturnReviewCard header="Return Pickup Requested">
      {/* Alert Message */}
      <div className="sui-mb-6">
        <Alert status="info">
          <Typography variant="body-base">
            Check your email for a scheduling link from Hub Group for each item
          </Typography>
        </Alert>
      </div>

      {/* Items List */}
      <div className="sui-space-y-6">
        {shipments.map((shipment) => {
          return shipment.itemsToReturn.map((item) => {
            const itemToReturn = lorpLineItems.find(
              (lineItem) => lineItem.lineItemId === item.lineItemId,
            );
            if (!itemToReturn) return null;
            return (
              <ItemDetails
                key={`shipment-${shipment.shipmentId}-item-${item.lineItemId}`}
                item={itemToReturn}
              />
            );
          });
        })}
      </div>

      {/* View Return Instructions Link */}
      <div className="sui-mt-6">
        <Link onClick={handleReturnInstructionsClick}>
          View Return Instructions
        </Link>
      </div>

      {/* LORP Contact Details */}
      <div className="sui-mt-6">
        <hr />
        <LORPContactDetails contactDetails={lorpContactDetails} />
      </div>
    </ReturnReviewCard>
  );
};
